type BackHandler = () => boolean

const handlers: BackHandler[] = []

export function registerBackHandler(handler: BackHandler) {
  handlers.push(handler)
  return () => {
    const index = handlers.indexOf(handler)
    if (index !== -1) {
      handlers.splice(index, 1)
    }
  }
}

export function hasBackHandler() {
  return handlers.length > 0
}

export function runTopBackHandler() {
  const handler = handlers.at(-1)
  return handler ? handler() : false
}
